import initializeComponent from 'Shared/react-initialize';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { theme } from '@carpenter/theme';
import { ComponentType } from 'react';

export const extendedTheme = extendTheme(theme);

export function Initializer<T>(Component: ComponentType<T>) {
   return (props: T) => (
      <ChakraProvider theme={extendedTheme} resetCSS={false}>
         <Component {...props} />
      </ChakraProvider>
   );
}

export function initializeChakraComponent(name: any, Component: any, defaultProps = {}) {
   initializeComponent(name, Initializer(Component), defaultProps);
}
